import React from 'react';
import ProductCardList from 'components/NewHome/ProductCardList';
import MobileProductModuleList from 'components/NewHome/Mobile/MobileProductModuleList';
import { meteorologyProductsList } from 'helper/Home/productCardList';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Meteorology() {
  if (useIsMobile()) {
    return <MobileProductModuleList title="METEOROLOGIA" products={meteorologyProductsList} />;
  }

  return (
    <div className="dark-outlet-background">
      <h1 className="mb-5">METEOROLOGIA</h1>
      <ProductCardList products={meteorologyProductsList} />
    </div>
  );
}
